"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgWatch = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24.9,
  height: 24.9,
  ...props,
  children: (0, jsx_runtime_1.jsx)("g", {
    "data-name": "Watch",
    children: (0, jsx_runtime_1.jsx)("g", {
      "data-name": "Component 40 \\u2013 1",
      children: (0, jsx_runtime_1.jsxs)("g", {
        "data-name": "Group 554",
        fill: "none",
        children: [(0, jsx_runtime_1.jsxs)("g", {
          "data-name": "Path 264",
          children: [(0, jsx_runtime_1.jsx)("path", {
            d: "M12.45 6.45a9.674 9.674 0 00-9 6 9.74 9.74 0 0012.531 5.346 9.565 9.565 0 005.469-5.346 9.675 9.675 0 00-9-6z"
          }), (0, jsx_runtime_1.jsx)("path", {
            d: "M12.45 7.95c-1.654 0-3.25.482-4.614 1.392a7.987 7.987 0 00-2.744 3.107 7.956 7.956 0 002.794 3.142 8.318 8.318 0 004.567 1.359c1.023 0 2.029-.187 2.99-.556a8.117 8.117 0 004.365-3.946 7.99 7.99 0 00-2.745-3.106A8.298 8.298 0 0012.45 7.95m0-1.5c3.976.002 7.545 2.381 9 5.998-.983 2.448-2.964 4.386-5.469 5.347C11.011 19.7 5.4 17.308 3.45 12.448c1.454-3.617 5.024-5.996 9-5.998z",
            fill: "#919191"
          })]
        }), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 265",
          d: "M12.39 10.45a2 2 0 102 2 2 2 0 00-2-2z",
          stroke: "#919191",
          strokeWidth: 1.5
        })]
      })
    })
  })
});
exports.default = SvgWatch;